import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "overview" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4 fw-bold" }, "Overview", -1)
const _hoisted_3 = { class: "card p-4 bg-light border-0 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxOverview = _resolveComponent("BoxOverview")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BoxOverview, { data: _ctx.tileData }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Chart, {
        type: "bar",
        data: _ctx.basicData,
        options: _ctx.option,
        class: "stacked-chart"
      }, null, 8, ["data", "options"])
    ])
  ]))
}